import React, { useContext, useEffect,Fragment } from "react";
import { Menu, Container, Button, Image, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import userauthStore from "../../app/stores/userauthStore";
import { observer } from "mobx-react-lite";

const NavBar = () => {
  const userAuthStore = useContext(userauthStore);
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 
  let IsLoggedIn = sessionStorage.getItem("isLoggedIn")
  
  useEffect(() => {
   userAuthStore.HydrateAuthState();
  }, [sessionObj, IsLoggedIn,userAuthStore]);


  function handleItemClick(e: any, d: any) {
    userAuthStore.SetFunctionMode(d.name);
  }

  function handleLogOut(e: any, d: any) {
  
    userAuthStore.SetLogout();
    window.location.assign("/login");
  }

  
  try {
  if(sessionObj.Client.Name == "Inquilab"){
  return (
    <div>
      <Menu header fixed="top" pointing stackable>
        <Container>
          <Menu.Item as={Link} to="/">
            <Image src="/assets/logo.png" size="small" alt="logo" />
          </Menu.Item>
          {IsLoggedIn === "true" || userAuthStore.isLoggedIn ===true ? (
            <Fragment>

              <Menu.Item
                name="Live Orders"
                as={Link}
                to="/liveorders"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Variations"
                as={Link}
                to="/variations"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Invoiced Orders"
                as={Link}
                to="/workorders"
                position="left"
                onClick={handleItemClick}
              />
              
              
              <Menu.Item
                name="Dashboards"
                as={Link}
                to="/dashboards"
                position="right"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Budget Tracker"
                as={Link}
                to="/budget"
                position="right"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Issue Log"
                position="right"
                href="https://docs.google.com/spreadsheets/d/1Q_YZAMv6nzzxD1eXKMsau2D5hGEhVGJ-z1Ac3Poa5IM/edit?ts=5e194706#gid=923105207"
                onClick={handleItemClick}
              />
               <Menu.Item
                name="Aged Debt"
                as={Link}
                to="/ageddebt"
                //float="left"
                onClick={handleItemClick}
              />
              

              <Menu.Menu position="right">
              <Image src={sessionObj.Logo} size="tiny" alt="logo"/>
                <Menu.Item> <Icon name="user"/> {sessionObj.User.FirstName} {sessionObj.User.LastName}</Menu.Item>
                <Menu.Item>
                  <Button negative content="Logout" onClick={handleLogOut} />
                </Menu.Item>
              </Menu.Menu>
            </Fragment>
          ) : (
            <div />
          )}
        </Container>
      </Menu>
    </div>
  );
};

if(sessionObj.Client.Name == "Watmos"){
    
  return (
    <div>
      <Menu header fixed="top" pointing stackable>
        <Container>
          <Menu.Item as={Link} to="/">
            <Image src="/assets/logo.png" size="small" alt="logo" />
          </Menu.Item>
          {IsLoggedIn === "true" || userAuthStore.isLoggedIn ===true ? (
            <Fragment>

              <Menu.Item
                name="Live Orders"
                as={Link}
                to="/liveorders"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Variations"
                as={Link}
                to="/variations"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Invoiced Orders"
                as={Link}
                to="/workorders"
                position="left"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Dashboards"
                as={Link}
                to="/WD"
                position="right"     
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Issue Log"
                href="https://gilmartins-my.sharepoint.com/:x:/g/personal/robbie_gilmartins_co_uk/Ef6fytZhnGtGubemEloj5zYBoqb_3ET4q_rEwPWRzb8oxg?rtime=iCYY6BbN2Eg"
                position="left"
              
                onClick={handleItemClick}
              />


              

              <Menu.Menu position="right">
              <Image src={sessionObj.Logo} size="tiny" alt="logo"/>
                <Menu.Item> <Icon name="user"/> {sessionObj.User.FirstName} {sessionObj.User.LastName}</Menu.Item>
                <Menu.Item>
                  <Button negative content="Logout" onClick={handleLogOut} />
                </Menu.Item>
              </Menu.Menu>
            </Fragment>
          ) : (
            <div />
          )}
        </Container>
      </Menu>
    </div>
  );
};

if(sessionObj.Client.Name == "Red Kite Housing"){
    
  return (
    <div>
      <Menu header fixed="top" pointing stackable>
        <Container>
          <Menu.Item as={Link} to="/">
            <Image src="/assets/logo.png" size="small" alt="logo" />
          </Menu.Item>
          {IsLoggedIn === "true" || userAuthStore.isLoggedIn ===true ? (
            <Fragment>

              <Menu.Item
                name="Live Orders"
                as={Link}
                to="/liveorders"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Invoiced Orders"
                as={Link}
                to="/workorders"
                position="left"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Variations"
                as={Link}
                to="/variations"
                position="left"

                onClick={handleItemClick}
              />
         
             
               <Menu.Item
                name="Availability"
                as={Link}
                to="/redkitejobs"
                position="left"
                onClick={handleItemClick}
              />
               <Menu.Item
                  name="Aged Debt"
                  as={Link}
                  to="/ageddebt"
                  //float="left"
                  onClick={handleItemClick}
                />
              

              <Menu.Menu position="right">
              <Image src={sessionObj.Logo} size="tiny" alt="logo"/>
                <Menu.Item> <Icon name="user"/> {sessionObj.User.FirstName} {sessionObj.User.LastName}</Menu.Item>
                <Menu.Item>
                  <Button negative content="Logout" onClick={handleLogOut} />
                </Menu.Item>
              </Menu.Menu>
            </Fragment>
          ) : (
            <div />
          )}
        </Container>
      </Menu>
    </div>
  );
};


// WATMOS
if(sessionObj.Client.Name === "Look Ahead"){
    
  return (
    <div>
      <Menu header fixed="top" pointing stackable>
        <Container>
          <Menu.Item as={Link} to="/">
            <Image src="/assets/logo.png" size="small" alt="logo" />
          </Menu.Item>
          {IsLoggedIn === "true" || userAuthStore.isLoggedIn ===true ? (
            <Fragment>

              <Menu.Item
                name="Live Orders"
                as={Link}
                to="/liveorders"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Variations"
                as={Link}
                to="/variations"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Invoiced Orders"
                as={Link}
                to="/workorders"
                position="left"
                onClick={handleItemClick}
              />
    
                 <Menu.Item
                name="Availability"
                as={Link}
                to="/lookaheadjobs"
                position="right"
                onClick={handleItemClick}
              />

                <Menu.Item
                  name="Aged Debt"
                  as={Link}
                  to="/ageddebt"
                  //float="left"
                  onClick={handleItemClick}
                />

              <Menu.Menu position="right">
              <Image src={sessionObj.Logo} size="tiny" alt="logo"/>
                <Menu.Item> <Icon name="user"/> {sessionObj.User.FirstName} {sessionObj.User.LastName}</Menu.Item>
                <Menu.Item>
                  <Button negative content="Logout" onClick={handleLogOut} />
                </Menu.Item>
              </Menu.Menu>
            </Fragment>
          ) : (
            <div />
          )}
        </Container>
      </Menu>
    </div>
  );
};


return(
  <div>
      <Menu header fixed="top" pointing stackable>
        <Container>
          <Menu.Item as={Link} to="/">
            <Image src="/assets/logo.png" size="small" alt="logo" />
          </Menu.Item>
          {IsLoggedIn === "true" || userAuthStore.isLoggedIn ===true ? (
            <Fragment>

              <Menu.Item
                name="Live Orders"
                as={Link}
                to="/liveorders"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Variations"
                as={Link}
                to="/variations"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Invoiced Orders"
                as={Link}
                to="/workorders"
                //float="left"
                onClick={handleItemClick}
              />
               {/* <Menu.Item
                name="Dashboards"
                as={Link}
                to="/dashboards"
                position="right"
                onClick={handleItemClick}
              /> */}

              <Menu.Item
                name="Aged Debt"
                as={Link}
                to="/ageddebt"
                //float="left"
                onClick={handleItemClick}
              />
            
              <Menu.Menu position="right">
              <Image src={sessionObj.Logo} size="tiny" alt="logo"/>
                <Menu.Item> <Icon name="user"/> {sessionObj.User.FirstName} {sessionObj.User.LastName}</Menu.Item>
                <Menu.Item>
                  <Button negative content="Logout" onClick={handleLogOut} />
                </Menu.Item>
              </Menu.Menu>
            </Fragment>
          ) : (
            <div />
          )}
        </Container>
      </Menu>
    </div>
  );

} catch (error) {
    
return(
  <div>
      <Menu header fixed="top" pointing stackable>
        <Container>
          <Menu.Item as={Link} to="/">
            <Image src="/assets/logo.png" size="small" alt="logo" />
          </Menu.Item>
          {IsLoggedIn === "true" || userAuthStore.isLoggedIn ===true ? (
            <Fragment>

              <Menu.Item
                name="Live Orders"
                as={Link}
                to="/liveorders"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Variations"
                as={Link}
                to="/variations"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Invoiced Orders"
                as={Link}
                to="/workorders"
                //float="left"
                onClick={handleItemClick}
              />
              <Menu.Item
                name="Aged Debt"
                as={Link}
                to="/ageddebt"
                //float="left"
                onClick={handleItemClick}
              />
               
            
              <Menu.Menu position="right">
              <Image src={sessionObj.Logo} size="tiny" alt="logo"/>
                <Menu.Item> <Icon name="user"/> {sessionObj.User.FirstName} {sessionObj.User.LastName}</Menu.Item>
                <Menu.Item>
                  <Button negative content="Logout" onClick={handleLogOut} />
                </Menu.Item>
              </Menu.Menu>
            </Fragment>
          ) : (
            <div />
          )}
        </Container>
      </Menu>
    </div>
  );
}
}


export default observer(NavBar);
